import { render, staticRenderFns } from "./OrderPayments.vue?vue&type=template&id=21c2d9b5&scoped=true"
import script from "./OrderPayments.vue?vue&type=script&lang=js"
export * from "./OrderPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c2d9b5",
  null
  
)

export default component.exports